(() => {
  
  let elements = document.querySelectorAll("#custom-digiloop-list");
  elements.forEach((parentNode) => {
    if (!parentNode)
      return;
    let optionList = parentNode.querySelector("ul");
    let options = parentNode.parentElement.querySelectorAll("#custom-digiloop-list > div");
    
    if (!optionList || !options) {
      console.log("Error: Optionlist or options not found");
      return;
    }
  
    // Purify list options from href elements
  
    optionList.querySelectorAll("[href]").forEach((element) => {
      element.removeAttribute("href");
    })
  
    // Make first option element selected
  
    optionList.querySelector("a").classList.add("list-item-selected");
    options[0].classList.add("list-item-content-shown");
  
    // Add event listeners
  
    function optionListClick(index) {
      optionList.querySelector(".list-item-selected").classList.remove("list-item-selected");
      parentNode.querySelector(".list-item-content-shown").classList.remove("list-item-content-shown");
      
      optionList.querySelectorAll("a")[index].classList.add("list-item-selected");
      options[index].classList.add("list-item-content-shown");

      if (window.innerWidth < 1024)
        options[index].scrollIntoView({ behavior: "smooth" });
    }
  
    optionList.querySelectorAll("a").forEach((element, index) => {
      element.addEventListener("click", () => { optionListClick(index) } );
    })
  })
})();